/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Ad_DvInputs */



/**
* | output |
* | --- |
* | "Automatic AD/DV^" |
*
* @param {Signup_Compare_Ad_DvInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_ad_dv = /** @type {((inputs?: Signup_Compare_Ad_DvInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Ad_DvInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Automatic AD/DV^")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatic AD/DV^")
	if (locale === "it") return /** @type {LocalizedString} */ ("Automatic AD/DV^")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Automatic AD/DV^")
	if (locale === "es") return /** @type {LocalizedString} */ ("Automatic AD/DV^")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Automatic AD/DV^")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Automatic AD/DV^")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Automatic AD/DV^")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Automatic AD/DV^")
	return /** @type {LocalizedString} */ ("Automatic AD/DV^")
});